import React, { Component } from "react";
import { connect } from "react-redux";
import { firestoreConnect, isLoaded, isEmpty } from "react-redux-firebase";
import { compose } from "redux";
import {
  Row,
  Col,
  Layout,
  PageHeader,
  Card,
  Skeleton,
  Typography,
  Avatar,
  Result,
  Table,
  Button,
  message,
  Spin,
  BackTop,
  Affix,
  Tooltip,
} from "antd";
import { getSessionBookings, bookSession, getUserFromPhone } from "../../store/actions/booking";
import {
  LoadingOutlined,
  CheckCircleTwoTone,
  CloseCircleTwoTone,
  ExclamationCircleTwoTone,
} from "@ant-design/icons";
import * as XLSX from "xlsx";

const spinIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
const errorIcon = (
  <CloseCircleTwoTone twoToneColor="#ff4d4f" style={{ fontSize: 24 }} />
);
const successIcon = (
  <CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: 24 }} />
);
const warnIcon = (
  <ExclamationCircleTwoTone twoToneColor="#faad14" style={{ fontSize: 24 }} />
);

class SessionBookingImport extends Component {
  state = {
    data: [],
    columns: [],
    importStarted: false,
    lastRecord: -1,
  };

  componentDidMount() {
    this.loadBookings();
  }

  loadBookings = async () => {
    const entityUid = `${this.props.classId}_${this.props.sessionId}`;
    await this.props.getSessionBookings({
      entityType: 'S',
      entityUid: entityUid
    });
  }

  // process CSV data
  processData = (dataString) => {
    this.setState({
      data: [],
      columns: [],
      importStarted: false,
      lastRecord: -1,
    });
    const dataStringLines = dataString.split(/\r\n|\n/);
    const headers = dataStringLines[0].split(
      /,(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)/
    );

    const list = [];
    for (let i = 1; i < dataStringLines.length; i++) {
      const row = dataStringLines[i].split(
        /,(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)/
      );
      if (headers && row.length === headers.length) {
        const obj = {};
        for (let j = 0; j < headers.length; j++) {
          let d = row[j];
          if (d.length > 0) {
            if (d[0] === '"') d = d.substring(1, d.length - 1);
            if (d[d.length - 1] === '"') d = d.substring(d.length - 2, 1);
          }
          if (headers[j]) {
            obj[headers[j]] = d;
          }
        }

        // remove the blank rows
        if (Object.values(obj).filter((x) => x).length > 0) {
          list.push(obj);
        }
      }
    }

    let isPhoneColumnAvailable = false;
    // prepare columns list from headers
    const columns = headers.map((c) => {
      if (c === "PhoneNumber") isPhoneColumnAvailable = true;
      return {
        title: c,
        dataIndex: c,
      };
    });

    if (!isPhoneColumnAvailable) {
      message.error(
        "The csv file doesn't contain a column named 'PhoneNumber'"
      );
      return;
    }
    columns.push({
      title: "Status",
      dataIndex: "status_b_rl",
    });
    this.setState({ data: list, columns });
  };

  sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  checkForExistingBooking(bookings, user) {
    bookings.map((booking) => {
      if (this.props.user.id === booking.student_uid) {
        return true;
      }
    });
    return false;
  }

  startImport = async () => {
    await this.setState({ importStarted: true });

    let { data, lastRecord } = this.state;
    let { bookings } = this.props;
    let len = data.length;

    for (let i = lastRecord + 1; i < len; i++) {
      console.log(data[i]);
      data[i]["status_b_rl"] = <Spin indicator={spinIcon} />;
      await this.setState({ data });
      await this.props.getUserFromPhone(data[i].PhoneNumber);
      if (this.props.user && isLoaded(bookings)) {
        // if (this.checkForExistingBooking(bookings, this.props.user)) {
        //   data[i]["status_b_rl"] = (
        //     <Tooltip title="Already has a booking">{warnIcon}</Tooltip>
        //   );
        //   continue;
        // }

        const timestamp = new Date().getTime();
        const orderId = `S_${this.props.classId}_${this.props.sessionId}_${this.props.user.id}_${timestamp}`;
        await this.props.bookSession(orderId, this.props.session.fee);
        if (this.props.bookError) {
          data[i]["status_b_rl"] = (
            <Tooltip title={this.props.bookError.message}>{errorIcon}</Tooltip>
          );
        } else {
          data[i]["status_b_rl"] = successIcon;
        }
      } else {
        data[i]["status_b_rl"] = (
          <Tooltip title="User not found!">{errorIcon}</Tooltip>
        );
      }

      await this.setState({ data });
      if (!this.state.importStarted) {
        await this.setState({ lastRecord: i, importStarted: false });
        break;
      }
    }
  };

  // handle file upload
  handleFileUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = (evt) => {
      /* Parse data */
      const bstr = evt.target.result;
      const wb = XLSX.read(bstr, { type: "binary" });
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      const data = XLSX.utils.sheet_to_csv(ws, { header: 1 });
      this.processData(data);
    };
    try {
      reader.readAsBinaryString(file);
    } catch (error) {
      //console.log(error);
    }
  };
  render() {
    const { bookings } = this.props;
    const { data, columns, importStarted } = this.state;

    if (bookings != null && isLoaded(bookings)) {
      return (
        <Layout>
          <PageHeader
            onBack={() => window.history.back()}
            ghost={false}
            title="Import bookings"
            className="site-page-header"
          ></PageHeader>
          <Row>
            <Col sm={{ span: 24 }} md={{ span: 24 }} justify="center">
              <Card
                title={"Import from csv"}
                style={{ margin: "1rem 1rem 0 1rem" }}
                extra={
                  <Affix offsetTop={20}>
                    <>
                      <Button
                        onClick={this.startImport}
                        disabled={data.length === 0 || importStarted}
                        key={1}
                        type="primary"
                      >
                        Start
                      </Button>
                      <Button
                        onClick={this.startImport}
                        disabled={data.length === 0 || !importStarted}
                        onClick={() => this.setState({ importStarted: false })}
                        key={2}
                      >
                        Stop
                      </Button>
                    </>
                  </Affix>
                }
              >
                <input
                  type="file"
                  accept=".csv"
                  onChange={this.handleFileUpload}
                />
                <BackTop />
                <Table
                  dataSource={data}
                  columns={columns}
                  rowKey={"PhoneNumber"}
                  pagination={false}
                />
              </Card>
            </Col>
          </Row>
        </Layout>
      );
    } else {
      return (
        <Layout>
          <PageHeader
            onBack={() => window.history.back()}
            ghost={false}
            title="Import bookings"
            className="site-page-header"
          ></PageHeader>
          <Row>
            <Col sm={{ span: 24 }} md={{ span: 24 }} justify="center">
              <Card
                title="Data is loading..."
                style={{ margin: "1rem 1rem 0 1rem" }}
                extra={<Skeleton.Button active />}
              >
                <Skeleton active />
              </Card>
            </Col>
          </Row>
        </Layout>
      );
    }
  }
}

const mapStateToProps = (state, routeProps) => {
  return {
    bookings: state.booking.sessionBookings
      ? state.booking.sessionBookings : [],
    session: state.firestore.ordered.selected_session
      ? state.firestore.ordered.selected_session[0]
      : null,
    selected_class: state.firestore.ordered.selected_class
      ? state.firestore.ordered.selected_class[0]
      : null,
    classId: routeProps.match.params.classId,
    sessionId: routeProps.match.params.sessionId,
    user: state.booking.users ? state.booking.users.docs[0] : null,
    bookError: state.booking.bookError,
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    getUserFromPhone: (phone) => dispatch(getUserFromPhone(phone)),
    getSessionBookings: (data) => dispatch(getSessionBookings(data)),
    bookSession: (orderId, amount) =>
      dispatch(
        bookSession({
          orderId,
          amount,
          reason: "Bulk Import Booking",
        })
      ),
  };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  firestoreConnect((routeProps) => [
    {
      collection: "classes",
      doc: routeProps.match.params.classId,
      storeAs: "selected_class",
    },
    {
      collection: "classes",
      doc: routeProps.match.params.classId,
      subcollections: [
        { collection: "sessions", doc: routeProps.match.params.sessionId },
      ],
      storeAs: "selected_session",
    }
  ])
)(SessionBookingImport);
